module.exports = __webpack_public_path__ + "static/media/cosmetic.28854632.svg";